/**

 * Product Form Components

 *

 */

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

    this.cartElement = document.querySelector("ajax-cart");

    this.qtyBtns = this.querySelectorAll("[data-qty-btn]");

    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
    );
  }

  /**

   * Product Form Submit event

   *

   * @param {evt} Event instance

   */

  async onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');

    const qtyInput = this.querySelector("[data-qty-input]");

    submitButton.setAttribute("disabled", true);

    submitButton.classList.add("loading");

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });

    var submitButtonOfGift = document.querySelector("#setDataToLocalStorage");
    if (submitButtonOfGift != null) {
      var gf_f_name = document.querySelector("#FirstNameNew").value;
      var gf_l_name = document.querySelector("#LastNameNew").value;
      var gf_phone = document.querySelector("#AddressPhoneNew").value;
      var gf_add_1 = document.querySelector("#AddressAddress1New").value;
      var gf_add_2 = document.querySelector("#AddressAddress2New").value;
      var gf_city = document.querySelector("#AddressCityNew").value;
      var gf_country = document.querySelector("#AddressCountryNew").value;
      var gf_province = document.querySelector("#AddressProvinceNew").value;
      var gf_zip = document.querySelector("#AddressZipNew").value;
      Utility.setLocalStorage("gf_f_name", gf_f_name);
      Utility.setLocalStorage("gf_l_name", gf_l_name);
      Utility.setLocalStorage("gf_phone", gf_phone);
      Utility.setLocalStorage("gf_add_1", gf_add_1);
      Utility.setLocalStorage("gf_add_2", gf_add_2);
      Utility.setLocalStorage("gf_city", gf_city);
      Utility.setLocalStorage("gf_country", gf_country);
      Utility.setLocalStorage("gf_province", gf_province);
      Utility.setLocalStorage("gf_zip", gf_zip);
    }

    var is_gift = document.querySelector(
      ".template--product-gift_subscription"
    );
    if (is_gift != null) {
      await fetch(`${routes.cart_clear_url}`, { ...fetchConfig("javascript") });
    } else {
      await fetch(`${routes.cart_fetch_url}`, { ...fetchConfig("javascript") })
        .then((response) => response.json())
        .then(async (data) => {
          window.cartJson = data;
          var cartItems = window.cartJson.items;
          for (var i = 0; i < cartItems.length; i++) {
            if (cartItems[i].properties != null) {
              var props = cartItems[i].properties;
              if (
                props["_Is_Gift_Product"] != null &&
                props["_Is_Gift_Product"] != undefined
              ) {
                var line = i + 1;
                await fetch(`${routes.cart_change_url}`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    line: line,
                    quantity: 0,
                  }),
                }).then((response) => {
                  return response.json();
                });
              }
            }
          }
        });
    }

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/cart";
        }
      })

      .catch((e) => {
        console.error(e);
      })

      .finally(() => {
        submitButton.classList.remove("loading");

        submitButton.removeAttribute("disabled");
        var is_gift = document.querySelector(
          ".template--product-gift_subscription"
        );
        if (is_gift != null) {
          document.querySelector('[name="properties[First_Name]"]').value = "";
          document.querySelector('[name="properties[Last_Name]"]').value = "";
          document.querySelector('[name="properties[Email]"]').value = "";
          document.querySelector('[name="properties[Gift_Message]"]').value =
            "";
        }

        setTimeout(function () {
          $("#check_upsell").trigger("click");
        }, 1000);
      });
  }

  /**

   * Product Form Quantity Input update action

   *

   * @param {event} Event instance

   */

  manageQtyBtn(event) {
    event.preventDefault();

    let currentTarget = event.currentTarget;

    let action = currentTarget.dataset.for || "increase";

    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");

    let currentQty = parseInt($qtyInput.value) || 1;

    let finalQty = 1;

    if (action == "decrease" && currentQty <= 1) {
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}

customElements.define("product-form", ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.form = this.closest("form");

    this.formType = this.form.dataset.format;

    var is_gift = document.querySelector(
      ".template--product-gift_subscription"
    );
    if (is_gift != null) {
      this.addBtn = this.form.querySelector(
        '[data-modal-opener="gift_subscription"]'
      );
    } else {
      this.addBtn = this.form.querySelector('[name="add"]');
    }

    this.variant_json = this.form.querySelector("[data-variantJSON]");

    this.variantPicker = this.dataset.type;

    if (this.formType == "product-page") this.onVariantChange();

    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.setCurrentVariant();

    if (!this.currentVariant) {
      this.toggleAddButton("disable");
    } else {
      if (this.formType == "grid") {
        const productGrid = this.closest("[data-product-grid]");

        this.renderProductInfo(this.currentVariant, productGrid);

        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest("[data-product-container]");

        this.renderProductInfo(this.currentVariant, productPage);
      }

      this.updateURLandID(this.currentVariant);

      this.toggleAddButton("enable");
    }
  }

  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;

    const variantURL = "?variant=" + this.currentVariant.id;

    const formLinks = productGrid.querySelectorAll(".product-link");

    formLinks.forEach((link) => {
      let href = link.href.split("?")[0];

      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];

    this.querySelectorAll(".variant_selector").forEach((selector) => {
      options.push(selector.value);
    });

    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors

    this.currentVariant = false;

    let options =
      this.variantPicker == "variant-select"
        ? this._getOptionsFromSelect()
        : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();

    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant

      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not

      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present

      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;

        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID

    if (this.formType == "product-page")
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${currentVariant.id}`
      );

    var is_gift = document.querySelector(
      ".template--product-gift_subscription"
    );
    if (is_gift != null) {
      var subscription_group_id = `variantJson_${currentVariant.id}_subscription_group_id`;
      var groupId = window[subscription_group_id];
      var subscription_month = `variantJson_${currentVariant.id}_subscription_month`;
      var giftMonth = window[subscription_month];
      var subscription_product_id = `variantJson_${currentVariant.id}_subscription_product_id`;
      var subscriptionProductId = window[subscription_product_id];
      var subscription_variant_id = `variantJson_${currentVariant.id}_subscription_variant_id`;
      var subscriptionVariantId = window[subscription_variant_id];
      document.querySelector('[name="properties[_Free_Month]"]').value =
        giftMonth;
      document.querySelector('[name="properties[_Gift_Product_Id]"]').value =
        subscriptionProductId;
      document.querySelector('[name="properties[_Gift_Variant_Id]"]').value =
        subscriptionVariantId;
      document.querySelector(
        '[name="properties[_Subscription_Group_Id]"]'
      ).value = groupId;
    }

    // update variant input with currentVariant Id

    const input = this.form.querySelector('input[name="id"]');

    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update

    let price = Shopify.formatMoney(
      currentVariant.price,
      window.globalVariables.money_format
    );

    let compare_price = Shopify.formatMoney(
      currentVariant.compare_at_price,
      window.globalVariables.money_format
    );

    let priceElement = container.querySelector("[data-currentPrice]");

    let comparePriceElement = container.querySelector("[data-comparePrice]");

    if (priceElement) priceElement.innerHTML = price;

    if (comparePriceElement) comparePriceElement.innerHTML = compare_price;

    // Grid Image Update on variant selection

    if (this.formType == "grid") {
      if (!currentVariant.featured_image) return;

      const featuredImage = container.querySelector("[data-feauredImage]");

      let updatedSrc = currentVariant.featured_image.src;

      if (updatedSrc) {
        featuredImage.src = updatedSrc;

        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;

      let imageID = currentVariant.featured_image.id;

      let imageSlide = document.querySelector(
        `.product--image[data-imageID="${imageID}"]`
      );

      if (this.formType == "quickshop") {
        imageSlide = document.querySelector(
          `.quickshop-slider .product--image[data-imageID="${imageID}"]`
        );
      }

      if (!imageSlide) return;

      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
        imageSlide
      );

      if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
      else if (quickShopSlider !== undefined && quickShopSlider)
        quickShopSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update

    let options = this.form.querySelectorAll("[data-optionindex]");

    options.forEach((option) => {
      let lableID = "option" + option.dataset.optionindex;

      const lable = option.querySelector(".selected-option");

      if (!lable || !lableID) return;

      lable.innerHTML = currentVariant[lableID];
    });
  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == "disable") {
      this.addBtn.setAttribute("disabled", true);

      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute("disabled", true);

      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute("disabled");

      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.addToCart;
    }
  }

  _getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.variant_json.textContent);

    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest("form");

    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector(".color-swatch");

    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll(".swatch");

      colorSwatches.forEach((swatch) => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset
          .handle;

        let swatchStyle = Utility.getSwatchStyle(colorHandle);

        swatch
          .querySelector(".swatch-label")
          .setAttribute("style", swatchStyle);
      });
    }
  }
}

customElements.define("variant-radios", VariantRadios);
